import { useCallback, useEffect, useState } from "react"

import { listLeadEnvelopes } from "../api/esign.services.ts"
import type { SigningEnvelope } from "../types/esign.types.ts"

type LeadSignatureRequestsState =
  | { status: "loading" }
  | { status: "ready"; envelopes: SigningEnvelope[] }
  | { status: "failed" }

export const useLeadSignatureRequests = (leadId: string | undefined) => {
  const [state, setState] = useState<LeadSignatureRequestsState>({
    status: "loading"
  })
  const [attempt, setAttempt] = useState(0)

  useEffect(() => {
    setState({ status: "loading" })
    if (!leadId) return
    let abandoned = false
    void listLeadEnvelopes(leadId).then((result) => {
      if (abandoned) return
      setState(
        result.ok
          ? {
              status: "ready",
              envelopes: (result.data ?? []).filter(
                (envelope) => envelope.status !== "draft"
              )
            }
          : { status: "failed" }
      )
    })
    return () => {
      abandoned = true
    }
  }, [leadId, attempt])

  const retry = useCallback(() => setAttempt((count) => count + 1), [])

  return { ...state, retry }
}
